import {nestServerPath} from "../../../api";

/**
 * В цвете хранится путь без хоста (бэкенд принимает только свои картинки):
 * `/car-colors/…` — начальные из client/public, `/api/file/static/…` — загруженные.
 */
export const COLOR_UPLOAD_PREFIX = "/api/file/static/";

/** Хост бэкенда в dev (`http://localhost:3200`); в проде — пусто, тот же origin. */
const apiOrigin = /^https?:\/\//.test(nestServerPath) ? nestServerPath.replace(/\/api\/?$/, "") : "";

/** Адрес картинки цвета для <img src>. */
export const colorImageSrc = (url: string | null | undefined): string | undefined => {
    if (!url) return undefined;
    if (url.startsWith("/api/")) return `${apiOrigin}${url}`;
    return `${process.env.PUBLIC_URL ?? ""}${url}`;
};
